import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';
import logo1 from '../../assets/contactBlogCareer/ISO_no.webp';
import logo2 from '../../assets/contactBlogCareer/DUNS.webp';
import logo3 from '../../assets/contactBlogCareer/Goodfirms.webp';
import footerlogo from '../../assets/contactBlogCareer/header2-logo.webp';
import phone from '../../assets/contactBlogCareer/phone.webp';
import email from '../../assets/contactBlogCareer/email.webp';
import address from '../../assets/contactBlogCareer/address.webp';

const Footer = ({ onLogoClick }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Handle logo click logic
  const handleLogoClick = (e) => {
    e.preventDefault();
    const currentPath = location.pathname;
    if (currentPath === '/') {
      if (onLogoClick) {
        onLogoClick();
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  // Helper function to define active link style
  const getActiveClassName = ({ isActive }) => (isActive ? 'active-footer-link' : '');

  return (
    <footer className="footer">
      {/* Background SVG waves */}
      <div className="background">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1600 900"
        >
          <defs>
            <linearGradient id="bg" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgba(0, 100, 100, 0.4)' }} />
              <stop offset="100%" style={{ stopColor: 'rgba(0, 255, 255, 0.7)' }} />
            </linearGradient>
            <path
              id="wave"
              fill="url(#bg)"
              d="M-363.852,502.589c0,0,236.988-41.997,505.475,0
              s371.981,38.998,575.971,0s293.985-39.278,505.474,5.859
              s493.475,48.368,716.963-4.995v560.106H-363.852V502.589z"
            />
          </defs>
          <g>
            <use xlinkHref="#wave" opacity=".3">
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="translate"
                dur="8s"
                values="270 230; -334 180; 270 230"
                repeatCount="indefinite"
              />
            </use>
            <use xlinkHref="#wave" opacity=".6">
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="translate"
                dur="6s"
                values="-270 230;243 220;-270 230"
                repeatCount="indefinite"
              />
            </use>
            <use xlinkHref="#wave" opacity=".9">
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="translate"
                dur="4s"
                values="0 230;-140 200;0 230"
                repeatCount="indefinite"
              />
            </use>
          </g>
        </svg>
      </div>

      {/* Content */}
      <div className="footer-container">
        {/* Column 1: About */}
        <div className="footer-about">
          <img
            src={footerlogo}
            alt="Oakya IT Logo"
            className="footer-logo"
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
          />
          <p>
            We combine creativity and expertise to deliver high-performing, responsive
            websites tailored to your needs. Our solutions enhance user experience and
            strengthen your online presence.
          </p>

          <div className="footer-social">
          <h4>Follow Us</h4>
          
          <div className="social-icons">
            <a
              href="https://www.facebook.com/oakyaitservices"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/oakya-it-services/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://x.com/oakyaitservices?s=21"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter / X"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.instagram.com/oakya_itservices/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        </div>

        

        {/* Column 2: Quick links */}
        
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink 
                to="/" 
                end 
                className={getActiveClassName}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className={getActiveClassName}>
                About Us
              </NavLink>
            </li>
            <li>
              <NavLink to="/expertise" className={getActiveClassName}>
                Expertise
              </NavLink>
            </li>
            <li>
              <NavLink to="/portfolio" className={getActiveClassName}>
                Portfolio
              </NavLink>
            </li>
            <li>
              <NavLink to="/career" className={getActiveClassName}>
                Career
              </NavLink>
            </li>
            <li>
              <NavLink to="/our-blog" className={getActiveClassName}>
                Our Blog
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={getActiveClassName}>
                Contact
              </NavLink>
            </li>
            
            
          </ul>
        </div>

        {/* Column 3: Our services Links */}
        <div className="footer-links-services">
          <h4>Our Services</h4>
          <ul>
            <li>
              <NavLink 
                to="/software-development" 
                end 
                className={getActiveClassName}>
                Software Development
              </NavLink>
            </li>
            <li>
              <NavLink to="/mobile-development" className={getActiveClassName}>
                Mobile Development
              </NavLink>
            </li>
            <li>
              <NavLink to="/ecommerce-development" className={getActiveClassName}>
                E -commerce Development
              </NavLink>
            </li>
            <li>
              <NavLink to="/website-development" className={getActiveClassName}>
                Website Development
              </NavLink>
            </li>
            <li>
              <NavLink to="/digital-marketing" className={getActiveClassName}>
                Digital Marketing
              </NavLink>
            </li>
            <li>
              <NavLink to="/branding" className={getActiveClassName}>
                Branding
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Column 4: Contact */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <div className="contact-item">
            <img src={phone} alt="Phone" className="contact-icon" loading="lazy" />
            <div className='footer-mobile-num'>
              <a href="tel:+919134747474">+91 9134747474</a>
            </div>
          </div>
          <div className="contact-item">
            <img src={email} alt="Email" className="contact-icon" loading="lazy" />
            <a href="mailto:info@oakyaitservices.com">info@oakyaitservices.com</a>
          </div>
          <div className="contact-item">
            <img src={address} alt="Address" className="contact-icon" loading="lazy" />
            <a
              href="https://www.google.com/maps?q=4th+Floor,+MKR+Enclave,+kamayyathopu,+Pantakaluva+Road,+NTR+Marg,+Kanuru,+Vijayawada,+Andhra+Pradesh"
              target="_blank"
              rel="noopener noreferrer"
            >
              4th Floor, MKR Enclave, kamayyathopu,
              Pantakaluva Road, NTR Marg, Kanuru,
              Vijayawada, Andhra Pradesh, 520007.
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-logos">
          <img src={logo1} alt="Logo 1" loading="lazy" />
          <img src={logo2} alt="Logo 2" loading="lazy" />
          <img src={logo3} alt="Logo 3" loading="lazy" />
        </div>
        &copy; {new Date().getFullYear()} Oakya IT Services Pvt Ltd. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;